import { useEffect, useState } from "react";
import { useParams, Link } from "react-router-dom";
import { api } from "@/lib/api";
import { fmtINR, fmtDateDMY } from "@/lib/format";
import { Card } from "@/components/ui/card";
import { Button } from "@/components/ui/button";

export default function ShiftEntryDetail() {
  const { entryId } = useParams();
  const [e, setE] = useState(null);
  useEffect(() => { api.get(`/shifts/${entryId}`).then((r) => setE(r.data)); }, [entryId]);
  if (!e) return <div>Loading…</div>;
  return (
    <div className="space-y-4" data-testid="entry-detail-root">
      <div className="flex items-start justify-between flex-wrap gap-2">
        <div>
          <h1 className="text-2xl sm:text-3xl font-bold tracking-tight text-slate-900">Shift Entry</h1>
          <p className="text-sm text-slate-600">{fmtDateDMY(e.date)} · {e.shift_code} · Cashier {e.cashier_name}</p>
        </div>
        <div className="flex gap-2">
          <Link to={`/shifts/${entryId}/edit`}><Button variant="outline" className="border-slate-300">Edit</Button></Link>
        </div>
      </div>

      <div className="grid grid-cols-2 md:grid-cols-4 gap-3">
        <Stat label="HSD (L)" v={e.hsd_litres} />
        <Stat label="MS (L)" v={e.ms_litres} />
        <Stat label="CNG (kg)" v={e.cng_kg} />
        <Stat label="Lubricants ₹" v={fmtINR(e.lubricant_total)} />
        <Stat label="Fuels Sales ₹" v={fmtINR(e.total_sales_fuels)} big />
        <Stat label="CNG Sales ₹" v={fmtINR(e.total_sales_cng)} big />
        <Stat label="Diff Fuels" v={fmtINR(e.difference_fuels)} bad={Math.abs(e.difference_fuels) > 10} />
        <Stat label="Diff CNG" v={fmtINR(e.difference_cng)} bad={Math.abs(e.difference_cng) > 10} />
      </div>

      <Section title="Nozzle Readings" rows={e.readings} cols={["nozzle_id","opening","closing","gross","trial_litres","net_litres","price","net_rs"]} />
      <Section title="Nozzle Adjustments" rows={e.adjustments} cols={["type","fuel","nozzle_id","deduction_litres","price","total_amount","reason"]} />
      <Section title="Lubricants" rows={e.lubricants} cols={["lub_id","qty","selling_price","total"]} />
      <Section title="Payments" rows={e.payments} cols={["pm_id","category","amount","payment_done_through"]} />
      <Section title="Debtor Entries" rows={e.debtors} cols={["debtor_id","fuel","amount_rs","qty"]} />
    </div>
  );
}
function Stat({ label, v, big, bad }) {
  return (
    <div className="bg-white border-2 border-slate-300 p-3 rounded-sm">
      <div className="text-xs font-bold uppercase tracking-wider text-slate-600">{label}</div>
      <div className={"font-mono font-bold mt-1 " + (big ? "text-3xl " : "text-xl ") + (bad ? "text-red-600" : "text-slate-900")}>{v}</div>
    </div>
  );
}
function Section({ title, rows = [], cols }) {
  return (
    <Card className="p-3 border-2 border-slate-300 rounded-sm">
      <h3 className="font-bold text-slate-800 mb-2">{title}</h3>
      {rows.length === 0 && <div className="text-sm text-slate-500">None</div>}
      {rows.length > 0 && (
        <div className="overflow-x-auto">
          <table className="dense-table w-full text-sm">
            <thead><tr>{cols.map((c) => <th key={c}>{c}</th>)}</tr></thead>
            <tbody>
              {rows.map((r, i) => <tr key={r.id || r._id || r.entry_id || `row-${i}`}>{cols.map((c) => <td key={c} className={typeof r[c] === "number" ? "num" : ""}>{typeof r[c] === "number" ? (["net_rs","price","total","amount","amount_rs","total_amount"].includes(c) ? fmtINR(r[c]) : r[c]) : (r[c] ?? "")}</td>)}</tr>)}
            </tbody>
          </table>
        </div>
      )}
    </Card>
  );
}
